import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { CircularProgress, Paper } from "@material-ui/core";
import { useEffect } from "react";
import { useState } from "react";
import userService from "../../../../services/user.service";
import { useSelector } from "react-redux";
import {
  permissionNames,
  userRoleKeyMap,
  userRoles,
  userSchoolName,
} from "../../../../utils/constant";
import PageNotFoundPage from "../../../../Common/PageNotFoundPage";

const HoursGraphChart = ({ isStorageManagementPage }) => {
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalHoursPurchased, settotalHoursPurchased] = useState(null);
  const [availableHours, setAvailableHours] = useState(null);
  const [sport, setSport] = useState("");
  const [seriesData, setSeriesData] = useState([]);
  const userInfo = useSelector(({ loggedInUser }) => {
    const role = loggedInUser.role;
    const user = loggedInUser[userRoleKeyMap[role]];
    return {
      role: role,
      schoolDetails:
        role == userRoles.ROLE_SCHOOL_ADMIN
          ? user
          : user[userSchoolName[role]][0].school,
      permissionRights: loggedInUser.userProfile.permissionRights.map(
        (item) => item.displayName
      ),
    };
  });

  useEffect(() => {
    setLoading(true);
    userService
      .getAllSportsHoursDetails(userInfo.schoolDetails.id)
      .then((res) => {
        const data = res.data.data;

        const storageData = data.details.map((item) => {
          const usedStorage = item.totalDuration.toFixed(4);
          return [item.month, Number(usedStorage)];
        });

        setSeriesData(storageData.reverse());
        settotalHoursPurchased(data.totalHoursPurchased);
        setSport(data.sportName);
        setAvailableHours(data.totalHoursAvailable.toFixed(3));
        setGraphData(data.details.reverse());
        setLoading(false);
      });
  }, []);

  const options = {
    title: {
      style: {
        color: "#002244",
        fontFamily: "Rajdhani-SemiBold",
      },
      enabled: false,
      text: null,
    },
    chart: {
      type: "spline",
      style: {
        color: "#002244",
      },
    },
    colors: [availableHours == 0 ? "red" : "#82ca9d"],
    xAxis: {
      gridLineWidth: 1,
      labels: {
        enabled: true,
        formatter: function () {
          return seriesData[this.value][0];
        },
        style: {
          color: "#002244",
          fontFamily: "Rajdhani-SemiBold",
          fontSize: "14px",
        },
      },
    },
    yAxis: {
      title: {
        text: null,
      },
    },
    series: [
      {
        name: "Hours Used",
        data: seriesData,
      },
    ],
    credits: {
      enabled: false,
    },
  };

  return (
    <>
      {userInfo.role == userRoles.ROLE_SCHOOL_ADMIN ||
      userInfo.permissionRights.includes(permissionNames.View_Data_Usage) ? (
        <div>
          {!loading ? (
            <div className={loading ? "gray-out " : ""}>
              <Paper className="graph-padding">
                <div className="text-left my-2 mx-3  d-flex justify-content-between">
                  <label className="bold fs-18"> {sport}</label>
                  <label className="bold fs-18 ">
                    (Available Hours:{" "}
                    <span className="text-primary">{availableHours}</span>)
                  </label>
                </div>
                <div className="pd-bottom-10" style={{ paddingRight: "5px" }}>
                  <HighchartsReact highcharts={Highcharts} options={options} />
                </div>
              </Paper>
            </div>
          ) : (
            <div
              className={`${
                isStorageManagementPage
                  ? "proggresshght"
                  : "content-layout-loading-animation"
              }`}
            >
              <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
                <CircularProgress
                  className="rounded-circle"
                  color="success"
                  sx={{ fontSize: 10, color: "#002244" }}
                  disableShrink
                />
              </div>
            </div>
          )}
        </div>
      ) : (
        <PageNotFoundPage />
      )}
    </>
  );
};

export default HoursGraphChart;
